import { styled } from '@mui/material';

import { PageBackground } from '@/components/Layout/Page/Page.styled';

export const Container = styled(PageBackground)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
}));

export const IllustrationContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
}));

export const Content = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',

  '.MuiButton-root': {
    margin: `0 auto`,
    padding: `0 ${theme.spacing(2)} 0 ${theme.spacing(2)}`,
  },
}));
